/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';

// Google Adwords Conversion Snippet
export const googleAdwordsScript = (tracker: ConversionTracker) => {
  return `<script type="text/javascript">
  /* <![CDATA[ */
	var google_conversion_id = ${tracker.tracking_pixel};
	var google_conversion_language = "en";
	var google_conversion_format = "3";
	var google_conversion_color = "ffffff";
	var google_conversion_label = "${
    tracker.tracking_label ??
    (tracker.variables && tracker.variables.tracking_label) ??
    ''
  }";
	var google_remarketing_only = false;
	/* ]]> */
	</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/${
    tracker.tracking_pixel
  }/?label=${
    tracker.tracking_label
  }&amp;guid=ON&amp;script=0"/></div></noscript>`;
};
